"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class CookiesManager {
  static getCookie(_ref) {
    let {
      name,
      encoded = false
    } = _ref;
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        let value = cookie.substring(cookieName.length, cookie.length);
        return encoded ? atob(value) : value;
      }
    }
    return null;
  }

  // setting the domain and path will create 2 cookies, one with the default domain and path and one with the given ones.
  // this way the current page will be able to read the cookie, and also the target page too.
  static setCookie(_ref2) {
    let {
      name,
      value,
      encoded = false,
      daysToExpire = 7,
      domain,
      path
    } = _ref2;
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    let cookie = `${name}=${encoded ? btoa(value) : value};${expires}`;
    if (domain) {
      cookie += `;domain=${domain}`;
    }
    if (path) {
      cookie += `;path=${path}`;
    }
    document.cookie = cookie;
  }
  static deleteCookie(name, domain, path) {
    document.cookie = `${name}=; domain=${domain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  }
}
var _default = CookiesManager;
exports.default = _default;